<template>
  <div v-if="errors && errors.length">
    <div class="d-block invalid-feedback visible" v-for="error in errors" :key="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'InvalidFeedback',
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped>
.visible {
  display: block;
}
</style>
